'use client';

import { c as _c } from "react/compiler-runtime";
import { TooltipComponent } from '@components/tooltip/TooltipComponent.jsx';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import styles from './ComfortMortgageInfo.module.scss';
export const ComfortMortgageInfo = t0 => {
  const $ = _c(6);
  const {
    content,
    isMobile,
    cardId
  } = t0;
  if (!content) {
    return null;
  }
  const t1 = `comfort-mortgage-${cardId}`;
  const t2 = isMobile ? "bottom" : "bottom-end";
  let t3;
  if ($[0] !== content) {
    t3 = <SafeHtmlRenderer tag="div" content={content} />;
    $[0] = content;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = <span className={styles.wrap}><TooltipComponent id={t1} place={t2}>{t3}</TooltipComponent></span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};